/** api */
import { axiosRequest } from './axiosRequest'
import config from './config.js'

const baseRequest = axiosRequest({
  baseURL: config.domain,
  // baseURL: 'https://servicedev.yflife.app',
  withCredentials: true
})

const debugRequest = axiosRequest({
  baseURL: 'https://cxdev.yflife.app',
  withCredentials: true
})
// console.log(config)
export const smtRequest = axiosRequest({
  baseURL: config.env === 'LOCAL' ? 'https://servicedev.yflife.app' : config.smtDomain,
  withCredentials: true
})

const request = config.env === 'LOCAL' ? debugRequest : baseRequest

export default request
